import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface TaskListCountResponse {
  totalTaskCount: number;
  rxErrorsTasksCount: number;
  labResultsTasksCount: number;
  labUnsolicitedTasksCount: number;
  labFailedTasksCount: number;
  labNeedsSubmissionTasksCount: number;
  questionnaireResponseReviewTasksCount: number;
}

export const useTaskListCount = (enabled = true) => {
  return useApi<TaskListCountResponse>({
    queryOptions: {
      enabled,
      queryFn: async () => {
        const response = await axiosInstance.get("/clinic/task-list/count");
        return response.data;
      },
      staleTime: 0,
      gcTime: 0,
      queryKey: QueryKeys.Provider.TASK_LIST_COUNT,
    },
  });
};
